import format from '../Strings/format';
import ArgumentException from './ArgumentException';
import SR from '../i18n/en/exceptions.strings.json';
export default class ArgumentNullException extends ArgumentException {
    constructor(argumentName, innerException) {
        const _message = format(SR.ArgumentNullException_message, argumentName);
        if (innerException) {
            super(argumentName, _message, innerException);
        }
        else {
            super(argumentName, _message);
        }
        this.name = 'ArgumentNullException';
    }
}
